/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-04 08:27:48
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
export declare namespace OrganizationConfigDOI {
    export interface RowDataI {
        id: number;
        name: string;
        parent_id: number;
        phone: string;
        principal: string;
        remark: string
    }
    export interface OrganizationI {
        id: number
        name: string
        parent_id: number
        children_list: OrganizationI[]
    }

    export interface QueryDetailResultI {}

    export interface OperateParamsI {
        id?:Integer
        name: string
        principal: string
        phone: string
        remark: string
        parent_id: Integer

    }
}
export default class OrganizationConfigApi {
    /**
     * 查询列表
     * @param {OrganizationConfigDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchSubordinate(organization_id: number): Promise<Result<OrganizationConfigDOI.RowDataI[]>> {
        return Api.post('/auth_login/system_all_department/query', { organization_id });
    }

    static async searchAllOrganization(): Promise<Result<OrganizationConfigDOI.OrganizationI[]>> {
        return Api.post('/auth_login/system_department_name/query');
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number }): Promise<Result<OrganizationConfigDOI.QueryDetailResultI>> {
        return Api.post('/base/garage/detail', params);
    }
    /**
     * 新增
     * @param {OrganizationConfigDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: OrganizationConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/auth_login/system_department_name/add', data);
    }

    /**
     * 修改
     * @param {OrganizationConfigDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: OrganizationConfigDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/auth_login/system_department_name/edit', data);
    }

    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(id: number ): Promise<Result<any>> {
        return Api.post('/auth_login/system_department_name/delete', {id});
    }

    static async queryOrganizationStation(organization_id: number ): Promise<Result<{device_id: number,select:1|2, device_name: string}[]>> {
        return Api.post('/monitor/device/organization/query', {organization_id});
    }
    static async querySysOrganizationStation(organization_id: number ,enterprise_id: number): Promise<Result<{device_id: number,select:1|2, device_name: string}[]>>{
        return Api.post('/monitor/device/organization/system_query', {organization_id,enterprise_id});
    }
    static async saveOrganizationStation(organization_id: number ,device_ids: number[]): Promise<Result<{device_id: number,select:1|2, device_name: string}>> {
        return Api.post('/monitor/device/organization/save', {organization_id,device_ids});
    }
    
    static async inheritOrganizationStation(organization_id: number ): Promise<Result<{device_id: number}[]>> {
        return Api.post('/monitor/device/superior_organization/inherit', {organization_id});
    }
}
